import React, { useState, useEffect, useRef } from 'react';
import { Loader, Dimmer } from 'semantic-ui-react';
import { TableBody, TableRow, TableCell } from '@material-ui/core';
import axios from 'axios';
import { Mensaje, MensajeSiNo } from '../../components/mensajes';
import CartasFinanza from './cartas';
import { formatMoneda, validaSoloNumero, validaMonto, formatoMonto } from '../../util/varios';
import moment from 'moment';
import { IncluirMovimiento } from './incluirMovimiento';
import useTable from "../../components/useTable";

import CatalogoBeneficiarios from '../../catalogos/catalogoBeneficiarios';
import CatalogoTipoRetenciones from '../../catalogos/catalogoTipoRetenciones';

const TablaTipoRetenciones = () => {
  var op = require('../../../public/modulos/datos');
  let token = sessionStorage.getItem('jwtToken');
  let anio = JSON.parse(sessionStorage.getItem('anioactu'));

  const accbtntipretenciones = JSON.parse(sessionStorage.getItem('accbtntipretencionesc'));
  const fechaTope = moment(JSON.parse(sessionStorage.getItem('fechasistema'))).format('YYYY-MM-DD').replace(anio.toString(), (anio - 18).toString());

  const btnCancela = useRef();
  const btnAcepta = useRef();

  const txtId = useRef();
  const txtDescripcion = useRef();
  const cmbTipo = useRef();
  const txtDeducible = useRef();
  const chkPorcen = useRef();
  const chkMilPorcen = useRef();
  const chkUniTri = useRef();
  const chkMontFij = useRef();
  const chkOtroPor = useRef();
  const txtOtroPorcen = useRef();
  const txtIdAgente = useRef();

  const [operacion, setOperacion] = useState(0);

  const [visibleBtn, setVisibleBtn] = useState('visible')
  const [visibleOtro, setVisibleOtro] = useState('collapse')
  const [visibleISLR, setVisibleISLR] = useState('hidden')
  const [tituloHeader, setTituloHeader] = useState('Gestionar Tipo de Retenciones.')

  const [habilitado, setHabilitado] = useState(true);
  const [catalogoBene, setCatalogoBene] = useState(false);
  const [catalogoTipoReten, setCatalogoTipoReten] = useState(false);
  const [tercero, setTercero] = useState({
    idagente: '',
    nombre: ''
  }
  )

  const [mensaje, setMensaje] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
  const [mensajesino, setMensajesino] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
  const [activate, setActivate] = useState(false);

  const [botones, setBotones] = useState({
    incluir: false,
    consultar: false,
    modificar: false,
    eliminar: false,
    aceptar: true,
    cancelar: true,
    catalogo: true,
    catalogoBene: true
  });
  const [values, setValues] = useState({
    idtiporetencion: '',
    descripcion: '',
    unidad: '',
    idcuentacontable: '',
    tipo: '',
    deducible: '',
    otro: '',
    idagente: '',
  });

  const handleInputNumChange = (event) => {
    event.preventDefault();
    validaSoloNumero(event);

    if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false;//alert(e.which);
  };

  const [ciudades, setCiudades] = useState();
  const [habilitadoNU, setHabilitadoNU] = useState(true);
  const [operacionPer, setOperacionPer] = useState(0);

  /*   const datosRes = () => {
      let campos = '*';
      let nomtab = 'persona';
      let nomid = 'cedula';
      let nomid2 = 'nacionalidad';
      let id = txtCedRes.current.value;
      let id2 = cmbNacionalidad.current.value;
      let endpoint = `${op.conexion}/api/consulta/modeli2?campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${id}&nomid2=${nomid2}&id2=${id2}`;
  
      setActivate(true);
      axios.get(endpoint, {
        headers: {
          'x-access-token': `${token}`
        }
      }).then(function (response) {
        if (response.status === 200) {
  
          cmbSexo.current.value = ''
          txtFechaNac.current.value = ''
          txtNomResp.current.value = ''
          txtApeResp.current.value = ''
          txtDescripcion.current.value = ''
          txtEmail.current.value = ''
          txtTlf1.current.value = ''
          txtTlf2.current.value = ''
  
          if (response.data !== '') {
            setHabilitadoNU(true);
            setOperacionPer(0);
            cmbSexo.current.value = response.data.sexo
            txtFechaNac.current.value = moment(response.data.fnacimiento).format('YYYY-MM-DD')
            txtNomResp.current.value = response.data.nombres
            txtApeResp.current.value = response.data.apellidos
            txtDescripcion.current.value = response.data.direccion
            txtEmail.current.value = response.data.correoe
            txtTlf1.current.value = response.data.tlf1
            txtTlf2.current.value = response.data.tlf2
            if (!botones.consultar) {
              btnCancela.current.focus();
            } else {
              btnAcepta.current.focus();
            }
  
          } else {
            txtNomResp.current.focus();
            setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'No existe una persona con este N° de cedula porfavor registre sus datos', icono: 'informacion' });
            setOperacionPer(1);
            setHabilitadoNU(false);
  
          }
        }
        setActivate(false);
      }).catch(function (error) {
        setActivate(false);
        setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
      })
    }; */


  const blanquear = () => {
    setOperacion(0)
    setTituloHeader('Gestionar Tipo de Retenciones.');
    chkPorcen.current.checked = false;
    chkMilPorcen.current.checked = false;
    chkUniTri.current.checked = false;
    chkMontFij.current.checked = false;
    chkOtroPor.current.checked = false;
    txtDeducible.current.value = '';
    txtOtroPorcen.current.value = '';
    setVisibleISLR('hidden')
    setVisibleOtro('collapse')
    setVisibleBtn('visible')
    setTercero({
      idagente: '',
      nombre: ''
    })
    setValues({
      idtiporetencion: '',
      descripcion: '',
      unidad: '',
      idcuentacontable: '',
      tipo: '',
      deducible: '',
      otro: '',
      idagente: '',
    })
    setBotones({
      incluir: false,
      consultar: false,
      modificar: false,
      eliminar: false,
      aceptar: true,
      cancelar: true,
      catalogo: true,
      catalogoBene: true
    });

    cmbTipo.current.value = '';
    txtId.current.value = '';
    txtDescripcion.current.value = '';
    txtIdAgente.current.value = ''

    setActivate(false);
    setOperacionPer(0);
    setHabilitado(true);
    setHabilitadoNU(true);


  }

  const procesarRegistro = () => {
    setActivate(true);
    let ope = 0;
    if (!botones.incluir) {
      ope = 1;
    } else if (!botones.modificar) {
      ope = 2;
    } else if (!botones.eliminar) {
      ope = 3;
    }
    let endpoint = `${op.conexion}/api/retenciones/actualizarretenciones`;

    let body;

    body = {
      operacion: ope,
      idtiporete: values.idtiporetencion === '' ? 0 : values.idtiporetencion,
      descrip: values.descripcion.toUpperCase().trim(),
      unid: parseInt(values.unidad),
      idcuentcon: 0,
      tip: parseInt(values.tipo),
      deducibl: txtDeducible.current.value === '' ? 0.00 : parseFloat(txtDeducible.current.value.replace(/\./g, '').replace(',', '.')),
      otr: txtOtroPorcen.current.value === '' ? 0.00 : parseFloat(txtOtroPorcen.current.value.replace(/\./g, '').replace(',', '.')),
      idagen: parseInt(tercero.idagente)
    }

    axios.post(endpoint, body, {
      headers: {
        'x-access-token': `${token}`
      }
    }).then(function (response) {
      if (response.status === 200) {
        if (ope === 1) {
          setMensaje({ mostrar: true, titulo: 'Exito.', texto: 'registro creado correctamente', icono: 'exito' });
        } else if (ope === 2) {
          setMensaje({ mostrar: true, titulo: 'Exito.', texto: 'registro modificado correctamente', icono: 'exito' });
        } else if (ope === 3) {
          setMensaje({ mostrar: true, titulo: 'Exito.', texto: 'registro eliminado correctamente', icono: 'exito' });
        }

        blanquear()

        setActivate(false);
      }
    }).catch(function (error) {
      let mensaje = '';
      if (error.response === undefined) {
        mensaje = 'Error de Conexion'
      } else {
        if (error.response.data.message === 'duplicate key value violates unique constraint "ubicacion_key"') {
          mensaje = 'Ya existe un Registro'

        }
        else {
          mensaje = error.response.data.message
        }
      }
      setMensaje({ mostrar: true, titulo: 'Error', texto: mensaje, icono: 'error' });
      setActivate(false);
    })
  };

  const handleInputMontoChange = (event) => {
    validaMonto(event);
    if (event.which === 13 || typeof (event.which) === 'undefined') {
      if (event.target.value === '' || parseFloat(event.target.value.trim().replace(".", "").replace(",", ".")) === 0.00) {
        event.target.value = '0,00'
      }
      event.target.value = (formatoMonto(event.target.value));
      let char1 = event.target.value.substring(0, 1);
      let char2 = event.target.value.substring(1, 2);
      if (char1 === '0' && char2 !== ',') {
        event.target.value = event.target.value.substring(1, event.target.value.legth);
      }
    } else if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false;
  };

  const handleCloseSi = () => {
    setActivate(false);
    setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' })
    procesarRegistro();


  };

  const onChange = (event) => {

    if (event.target.name === 'descripcion') {
      event.target.value = event.target.value;
      setValues({ ...values, [event.target.name]: event.target.value });
    } else if (event.target.name === 'unidad') {
      if (event.target.value === '4') {
        setVisibleOtro('visible')
      } else {
        setVisibleOtro('collapse')
        txtOtroPorcen.current.value = ''
      }
      setValues({ ...values, [event.target.name]: event.target.value });

    } else if (event.target.name === 'tipo') {
      if (event.target.value === '1') {
        setVisibleISLR('visible')
      } else {
        setVisibleISLR('hidden')
        txtDeducible.current.value = ''
      }
      setValues({ ...values, [event.target.name]: event.target.value });


    }
    else {
      setValues({ ...values, [event.target.name]: event.target.value });
    }
  }

  const seleccionarRegistroBene = (id) => {

    let campos = 'idagente, nombre';
    let nomtab = 'agente';
    let condi = "agenteretencion = true and idagente = " + id;
    let orden = 'idagente';

    let endpoint = `${op.conexion}/api/consulta/selecionarregistrocondi?&campos=${campos}&nomtab=${nomtab}&condi=${condi}&orden=${orden}`;

    setActivate(true);
    axios.get(endpoint, {
      headers: {
        'x-access-token': `${token}`
      }
    }).then(function (response) {
      if (response.status === 200) {

        setTercero({
          idagente: '',
          nombre: ''
        })


        if (response.data[0].idagente !== undefined) {

          txtIdAgente.current.value = response.data[0].idagente;
          setTercero({
            idagente: response.data[0].idagente,
            nombre: response.data[0].nombre
          })

        } else {


        }
      }
      setActivate(false);
    }).catch(function (error) {
      setActivate(false);
      setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'No existe un Fondo de Tercero con este codigo', icono: 'informacion' });
    })
  };


  const seleccionarRegistroTipReten = () => {
    let campos = '*';
    let nomtab = 'tiporetencion';
    let nomid = 'idtiporetencion';
    let id = txtId.current.value;
    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${id}`;

    setActivate(true);
    axios.get(endpoint, {
      headers: {
        'x-access-token': `${token}`
      }
    }).then(function (response) {
      if (response.status === 200) {



        if (response.data !== '') {

          if (parseInt(response.data.tipo) === 1) {
            setVisibleISLR('visible');
            txtDeducible.current.value = formatMoneda(response.data.deducible.toString().replace(',', '').replace('.', ','), ',', '.', 2);
          }

          switch (parseInt(response.data.unidad)) {
            case 0:
              chkPorcen.current.checked = true;
              break;
            case 1:
              chkMilPorcen.current.checked = true;
              break;
            case 2:
              chkUniTri.current.checked = true;
              break;
            case 3:
              chkMontFij.current.checked = true;
              break;
            case 4:
              chkOtroPor.current.checked = true;
              setVisibleOtro('visible');
              txtOtroPorcen.current.value = formatMoneda(response.data.otro.toString().replace(',', '').replace('.', ','), ',', '.', 2);
              break;

          }

          cmbTipo.current.value = response.data.tipo;
          txtId.current.value = response.data.idtiporetencion;

          seleccionarRegistroBene(response.data.idagente)

          setValues(
            response.data
          )


        } else {
          setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'No existe un Tipo de Retención con este codigo', icono: 'informacion' });
          txtDescripcion.current.value = '';
        }
      }
      setActivate(false);
    }).catch(function (error) {
      setActivate(false);
      setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
    })
  };

  const validarTipoReten = (event) => {
    event.preventDefault();
    validaSoloNumero(event);
    if (event.which === 13 || typeof (event.which) === 'undefined') {
      if (event.target.value !== '') {

        seleccionarRegistroTipReten();

      } else {
        chkPorcen.current.checked = false;
        chkMilPorcen.current.checked = false;
        chkUniTri.current.checked = false;
        chkMontFij.current.checked = false;
        chkOtroPor.current.checked = false;
        txtDeducible.current.value = '';
        txtOtroPorcen.current.value = '';
        setVisibleISLR('hidden')
        setVisibleOtro('collapse')
        setTercero({
          idagente: '',
          nombre: ''
        })
        setValues({
          idtiporetencion: '',
          descripcion: '',
          unidad: '',
          idcuentacontable: '',
          tipo: '',
          deducible: '',
          otro: '',
          idagente: '',
        })
        txtId.current.value = '';
      }
    }
  };

  const validarBene = (event) => {
    event.preventDefault();
    validaSoloNumero(event);

    if (event.which === 13 || typeof (event.which) === 'undefined') {

      if (event.target.value !== '') {


        seleccionarRegistroBene(event.target.value);

      } else {
        setTercero({
          idagente: '',
          nombre: ''
        })
        txtIdAgente.current.value = '';
      }
    }
  };


  const onCatalogoBene = (values) => {
    setCatalogoBene(false);
    setTercero(values)
    txtIdAgente.current.value = values.idagente
    if (!botones.modificar) {
      setBotones({ ...botones, catalogoBene: false });
    }
  }
  const onCatalogoTipoRetn = (value) => {
    setCatalogoTipoReten(false);
    if (parseInt(value.tipo) === 1) {
      setVisibleISLR('visible');
      txtDeducible.current.value = formatMoneda(value.deducible.toString().replace(',', '').replace('.', ','), ',', '.', 2);
    }

    switch (parseInt(value.unidad)) {
      case 0:
        chkPorcen.current.checked = true;
        break;
      case 1:
        chkMilPorcen.current.checked = true;
        break;
      case 2:
        chkUniTri.current.checked = true;
        break;
      case 3:
        chkMontFij.current.checked = true;
        break;
      case 4:
        chkOtroPor.current.checked = true;
        setVisibleOtro('visible');
        txtOtroPorcen.current.value = formatMoneda(value.otro.toString().replace(',', '').replace('.', ','), ',', '.', 2);
        break;

    }

    cmbTipo.current.value = value.tipo;
    txtId.current.value = value.idtiporetencion;
    txtIdAgente.current.value = value.idagente;

    setValues({
      idtiporetencion: value.idtiporetencion,
      descripcion: value.descripcion.trim(),
      unidad: value.unidad,
      idcuentacontable: value.idcuentacontable,
      tipo: value.tipo,
      deducible: value.deducible,
      otro: value.otro,
      idagente: value.idagente,
    })
    setTercero({
      idagente: value.idagente,
      nombre: value.nombre
    })


    if (!botones.modificar) {
      setBotones({ ...botones, catalogoBene: false });
    }
  }

  const onChangeValidar = () => {

    let sigue = true;

    if (!botones.incluir || !botones.modificar) {


      if (visibleISLR === 'visible' && txtDeducible.current.value === '') {

        setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Debe Ingresar el Deducible.', icono: 'informacion' });
        sigue = false;
        txtDeducible.current.focus();

      } else if (txtDescripcion.current.value === '') {

        setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Debe Ingresar la Descripción.', icono: 'informacion' });
        sigue = false;
        txtDescripcion.current.focus();

      } else if (values.unidad === '') {

        setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Debe Seleccionar una Unidad de Retención .', icono: 'informacion' });
        sigue = false;
        chkPorcen.current.focus();

      } else if (parseInt(values.unidad) === 4 && txtOtroPorcen.current.value === '') {

        setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Debe Ingresar un Porcentaje.', icono: 'informacion' });
        sigue = false;
        txtOtroPorcen.current.focus();

      } else if (tercero.idagente === '') {

        setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Debe Seleccionar un Fondo de Terceros.', icono: 'informacion' });
        sigue = false;
        txtIdAgente.current.focus();

      }



    }
    if (sigue) {

      let msg = '';
      if (!botones.incluir) {
        msg = 'Esta Seguro de Registrar estos Datos.';
      } else if (!botones.modificar) {
        msg = 'Esta Seguro de Modificar estos Datos.';
      } else if (!botones.eliminar) {
        msg = 'Esta Seguro de Eliminar estos Datos.';
      }

      setMensajesino({ mostrar: true, titulo: 'Confirmación.', texto: msg, icono: 'confirmacion' });


    }
  }

  const onBotones = (op) => (e) => {

    setOperacion(op)
    e.preventDefault();

    if (op === 1) {

      if (accbtntipretenciones && accbtntipretenciones.toString().substring(0, 1) === '1') {
        setVisibleBtn('hidden');
        setTituloHeader('Incluir Tipo de Retenciones.')
        setHabilitado(false);
        setBotones({
          incluir: false,
          consultar: true,
          modificar: true,
          eliminar: true,
          aceptar: false,
          cancelar: false,
          catalogo: true,
          catalogoBene: false
        });
        txtDescripcion.current.removeAttribute("disabled");
        txtDescripcion.current.focus();
      } else {
        setMensaje({ mostrar: true, titulo: 'Notificación.', texto: '¡No Posee Permiso para Realizar esta Acción!', icono: 'error' });
      }

    } else if (op === 2) {

      if (accbtntipretenciones && accbtntipretenciones.toString().substring(1, 2) === '1') {
        setTituloHeader('Editar Tipo de Retenciones.')
        setVisibleBtn('hidden');
        setHabilitado(false);
        setBotones({
          incluir: true,
          consultar: true,
          modificar: false,
          eliminar: true,
          aceptar: false,
          cancelar: false,
          catalogo: false,
          catalogoBene: true
        });
        txtId.current.removeAttribute("disabled");
        txtId.current.focus();
      } else {
        setMensaje({ mostrar: true, titulo: 'Notificación.', texto: '¡No Posee Permiso para Realizar esta Acción!', icono: 'error' });
      }

    } else if (op === 3) {

      if (accbtntipretenciones && accbtntipretenciones.toString().substring(3, 4) === '1') {
        setTituloHeader('Eliminar Tipo de Retenciones.')
        setVisibleBtn('hidden');
        setHabilitado(true);
        setBotones({
          incluir: true,
          consultar: true,
          modificar: true,
          eliminar: false,
          aceptar: false,
          cancelar: false,
          catalogo: false,
          catalogoBene: true
        });
        txtId.current.removeAttribute("disabled");
        txtId.current.focus();
      } else {
        setMensaje({ mostrar: true, titulo: 'Notificación.', texto: '¡No Posee Permiso para Realizar esta Acción!', icono: 'error' });
      }

    } else if (op === 4) {

      if (accbtntipretenciones && accbtntipretenciones.toString().substring(2, 3) === '1') {
        setTituloHeader('Consultar Tipo de Retenciones.')
        setVisibleBtn('hidden');
        setHabilitado(true);
        txtId.current.focus()
        setBotones({
          incluir: true,
          consultar: false,
          modificar: true,
          eliminar: true,
          aceptar: true,
          cancelar: false,
          catalogo: false,
          catalogoBene: true
        });
        txtId.current.removeAttribute("disabled");
        txtId.current.focus();
      } else {
        setMensaje({ mostrar: true, titulo: 'Notificación.', texto: '¡No Posee Permiso para Realizar esta Acción!', icono: 'error' });
      }

    } else if (op === 5) {
      onChangeValidar();
    } else if (op === 6) {
      setVisibleBtn('visible');
      blanquear();
    }
  }

  return (
    <div style={{ height: '100%', width: '100%' }}>
      <div className="row col-md-12 py-5" style={{ margin: 0 }}>
        <div className='row col-md-12 py-2' style={{ margin: 0 }}>
          {/*  <div className='col-md-8 mx-auto'>
              <CartasFinanza/>
              </div> */}
          <div className='col-md-8 py-3 mx-auto card shadow '>

            <div className='col-md-12 row mx-auto  rounded py-2'>
              <div className='col-md-12 border-azul rounded py-2 row mx-auto mb-3 azulGradiant shadow text-light justify-content-between'>
                <div className='col-md-6'>

                  <h3>
                    {tituloHeader}
                  </h3>


                </div>
                <div className='col-md-3 d-flex justify-content-end'>

                  <a href='/inicio' className='text-light '><i className="fas fa-times mx-2"></i><span className='fw-bold'>Salir</span></a>

                </div>
              </div>
              <div className='row mx-auto border-azul py-3 rounded' style={{ fontSizeAdjust: '0.7' }}>

                <div className="input-group input-group-sm mb-2 col-md-2 col-xl-3 col-lg-4 col-md-4 col-sm-4" style={{ visibility: parseInt(operacion) === 1 ? 'hidden' : 'visible' }}>
                  <label className="input-group-text" id="inputGroup-sizing-sm">CODIGO:</label>

                  <input type="text" name='idcuentabancaria' className="form-control fs-6" disabled ref={txtId} defaultValue={values.idtiporetencion !== null || values.idtiporetencion !== '' ? values.idtiporetencion.trim() : ''} aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" onKeyUp={validarTipoReten} onBlur={validarTipoReten} />
                  <button type="button" disabled={botones.catalogo} onClick={() => { setCatalogoTipoReten(true) }} className="btn btn-success"><i className="fas fa-search"></i></button>

                </div>

                <div className="input-group input-group-sm mb-2 col-xl-4 col-lg-4 col-md-6 col-sm-6">
                  <label className="input-group-text" id="inputGroup-sizing-sm">TIPO DE PLANILLA:</label>
                  <select className="form-select text-uppercase" aria-label="Default select example" name="tipo" ref={cmbTipo} id="tipo" onChange={onChange} disabled={habilitado}>
                    <option value=""> Seleccione</option>
                    <option value="0"> Planilla IVA</option>
                    <option value="1">  Planilla ISLR</option>
                    <option value="2">  Planilla 1 X 500</option>

                  </select>
                </div>

                <div className='input-group input-group-sm mb-2 col-pd-230 ml-auto px-2' style={{ visibility: visibleISLR }} >
                  <label className="input-group-text" id="inputGroup-sizing-sm">DEDUCIBLE:</label>
                  <input type="text" className="form-control col-md-10 nx-auto form-control-sm rounded text-right fs-6" ref={txtDeducible} placeholder='0,00' name='deducible' disabled={habilitado} onKeyUp={handleInputMontoChange} onBlur={handleInputMontoChange} ></input>
                </div>

                <div className="input-group input-group-sm col-md-12  mb-2">
                  <label className="input-group-text" id="inputGroup-sizing-sm">DESCRIPCION:</label>
                  <input type="text" className="form-control rounded text-uppercase fs-6" ref={txtDescripcion} disabled={habilitado} value={values.descripcion !== null || values.descripcion !== '' ? values.descripcion : ''} name='descripcion' onChange={onChange}></input>
                </div>

                <div className='col-md-12 mt-2 px-0'>
                  <fieldset className=' row col-sm-12 mx-auto border-azul rounded d-flex justify-content-between '>
                    <legend className="float-none w-auto fw-bold" style={{ fontSize: '15px' }}>Unidad de Retención</legend>
                    <div className='col d-flex jsutify-content-center mb-2'>

                      <div className="form-check mx-auto">
                        <input className="form-check-input my-auto" type="radio" name="unidad" id="unidad" ref={chkPorcen} onChange={onChange} value={0} disabled={habilitado} />
                        <span className="my-auto form-check-label" for="flexRadioDefault1" style={{ fontSize: '13px' }}>
                          Porcentaje
                        </span>
                      </div>
                    </div>

                    <div className='col d-flex jsutify-content-center mb-2'>
                      <div className="form-check mx-auto">
                        <input className="form-check-input my-auto" type="radio" name="unidad" id="unidad" ref={chkMilPorcen} onChange={onChange} value={1} disabled={habilitado} />
                        <span className="my-auto form-check-label" for="flexRadioDefault1" style={{ fontSize: '13px' }}>
                          Mil Porciento
                        </span>
                      </div>

                    </div>

                    <div className='col d-flex jsutify-content-center mb-2'>
                      <div className="form-check mx-auto">
                        <input className="form-check-input my-auto" type="radio" name="unidad" id="unidad" ref={chkUniTri} onChange={onChange} value={2} disabled={habilitado} />
                        <span className="my-auto form-check-label" for="flexRadioDefault1" style={{ fontSize: '13px' }}>
                          Unidad Tributaria
                        </span>
                      </div>

                    </div>

                    <div className='col d-flex jsutify-content-center mb-2'>
                      <div className="form-check mx-auto">
                        <input className="form-check-input my-auto" type="radio" name="unidad" id="unidad" ref={chkMontFij} onChange={onChange} value={3} disabled={habilitado} />
                        <span className="my-auto form-check-label" for="flexRadioDefault1" style={{ fontSize: '13px' }}>
                          Monto Fijo
                        </span>
                      </div>

                    </div>

                    <div className='col d-flex jsutify-content-center mb-2'>
                      <div className="form-check mx-auto">
                        <input className="form-check-input my-auto" type="radio" name="unidad" id="unidad" ref={chkOtroPor} onChange={onChange} value={4} disabled={habilitado} />
                        <span className="my-auto form-check-label" for="flexRadioDefault1" style={{ fontSize: '13px' }}>
                          Otro Porcentaje:
                        </span>
                      </div>
                    </div>

                    <div className="input-group input-group-sm col-1  d-flex jsutify-content-center mb-2 px-0" style={{ visibility: visibleOtro }}>
                      <input type="text" className="form-control fs-6 px-1 text-right" ref={txtOtroPorcen} maxLength={6} placeholder='0,00' name='otro' disabled={habilitado} onKeyUp={handleInputMontoChange} onBlur={handleInputMontoChange}></input>
                      <span className="input-group-text px-1" id="inputGroup-sizing-sm">%</span>
                    </div>

                    {/*  <div className='col-1 '  >
                      <input type="text" aria-describedby="inputGroup-sizing-sm" className="form-control form-control-sm rounded mx-0 text-right fs-6" ref={txtOtroPorcen} placeholder='0,00' name='otro' disabled={habilitado} onKeyUp={handleInputMontoChange} onBlur={handleInputMontoChange}></input>
                    </div> */}

                  </fieldset>
                </div>
                <div className='col-md-12 mt-2 px-0'>
                  <fieldset className=' row col-sm-12 mx-auto border-azul rounded d-flex justify-content-between '>
                    <legend className="float-none w-auto fw-bold" style={{ fontSize: '15px' }}>Fondo de Terceros</legend>

                    <div className="input-group input-group-sm mb-2 col-md-12 col-lg-12">
                      <label className="input-group-text" id="inputGroup-sizing-sm">CODIGO:</label>

                      <input type="text" ref={txtIdAgente} name='idcuentabancaria' className="form-control col-md-2 fs-6" disabled={habilitado} defaultValue={tercero.idagente !== null || tercero.idagente !== '' ? tercero.idagente : ''} aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" onKeyUp={validarBene} />
                      <button type="button" disabled={botones.catalogoBene} onClick={() => { setCatalogoBene(true) }} className="btn btn-success"><i className="fas fa-search"></i></button>
                      <input type="text" name='idcuentabancaria' disabled className="form-control fs-6" defaultValue={tercero.nombre !== null || tercero.nombre !== '' ? tercero.nombre.trim() : ''} aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />

                    </div>


                  </fieldset>
                </div>

              </div>

              <div className='col-md-12 d-flex justify-content-between mt-3'>
                {visibleBtn === 'visible' ? <div className='col-pd-600 d-flex justify-content-start'>
                  <button disabled={botones.incluir} onClick={onBotones(1)} className="btn btn-sm mx-1 btn-primary rounded-pill" title='Incluir Almacen'><i className="fas fa-plus"> Incluir </i> </button>
                  <button disabled={botones.consultar} onClick={onBotones(4)} className="btn btn-sm mx-1 btn-info rounded-pill" title='Consultar Almacen' ><i className="fas fa-eye">Consultar</i> </button>
                  <button disabled={botones.modificar} onClick={onBotones(2)} className="btn btn-sm mx-1 btn-warning rounded-pill" title='Modificar Almacen'><i className="fa fa-edit">Modificar</i> </button>
                  <button disabled={botones.eliminar} onClick={onBotones(3)} className="btn btn-sm mx-1 btn-danger rounded-pill" title='Eliminar Almacen'><i className="fa fa-trash">Eliminar</i> </button>
                </div> : <div className='col-md-150 d-flex justify-content-end ml-auto'>
                  <button ref={btnAcepta} disabled={botones.aceptar} onClick={onBotones(5)} className="mx-2 btn btn-sm rounded-pill btn-success"><i className="fas fa-check-circle">  Aceptar</i></button>
                  <button ref={btnCancela} disabled={botones.cancelar} onClick={onBotones(6)} className="mx-2 btn btn-danger btn-sm rounded-pill"><i className="fas fa-window-close"> Cancelar</i></button>
                </div>}
              </div>
            </div>

          </div>

        </div>
      </div >
      <CatalogoBeneficiarios
        show={catalogoBene}
        onHideCancelar={() => { setCatalogoBene(false) }}
        onHideAceptaCatalogo={onCatalogoBene}
      />

      <CatalogoTipoRetenciones
        show={catalogoTipoReten}
        onHideCancelar={() => { setCatalogoTipoReten(false) }}
        onHideAceptaCatalogo={onCatalogoTipoRetn}
      />


      <Dimmer active={activate} inverted>
        <Loader inverted>cargando...</Loader>
      </Dimmer>
      <Mensaje mensaje={mensaje}
        onHide={() => setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })} />
      <MensajeSiNo mensaje={mensajesino}
        onHideNo={() => setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' })} onHideSi={handleCloseSi} />
    </div>
  );
}
export default TablaTipoRetenciones;


// WEBPACK FOOTER //
// ./src/components/finanzas/tablaRetenciones.js